module.exports = __webpack_public_path__ + "static/media/plus.b1ef1f1c.svg";